import { apiRequest } from "@/data/api/client";
import { toToday, type TodayPayload } from "@/data/mappers/today.mapper";
import type { Today } from "@/domain/today/types";

export const partnerTodayRepo = {
  async get(): Promise<Today> {
    return toToday(await apiRequest<TodayPayload>("/v1/partner/today"));
  },
};
